import { useStaticQuery, graphql } from "gatsby"

export default function useSurveyResultsData() {
  const data = useStaticQuery(graphql`
  {
    allFile(filter: {sourceInstanceName: {eq: "survey-results"}}) {
      edges {
        node {
          name
          id
          relativePath
          childMarkdownRemark {
            html
            frontmatter {
              icon
              title
              uses_nivo_chart
              is_multiyear
              graphic {
                id
                childImageSharp {
                  fluid(maxWidth: 1000) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
              uses_legend
              crowdsignal_question_number
              chart_type
              include_community_insight
              insight_quote
              insight_name
              insight_bio
              insight_image {
                publicURL
                childImageSharp {
                  fixed(cropFocus: CENTER, width: 110, height: 110) {
                    ...GatsbyImageSharpFixed
                  }
                }
              }
              custom_chart_height
              display_other
              other_tags_title
              other_tags
              ranked_linkable_list {
                display_text
                url
                tag
                list_item_image {
                  id
                  childImageSharp {
                    fluid(maxWidth: 310) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
          sourceInstanceName
        }
      }
    }
  }
`)
  return data.allFile.edges
}
